import React from "react";
import "../styles/OnboardingTour.css";

const OnboardingTour = ({
  step,
  stepNumber,
  totalSteps,
  onNext,
  onBack,
  onSkip,
  isFirstStep,
  isLastStep
}) => {
  if (!step) return null;

  const progressPercent = Math.round((stepNumber / totalSteps) * 100);

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-card" role="dialog" aria-modal="true" aria-label="Onboarding tutorial">
        <div className="onboarding-header">
          <div className="onboarding-badge">Tutorial</div>
          <button className="onboarding-skip" onClick={onSkip}>Skip</button>
        </div>

        <div className="onboarding-progress">
          <div className="onboarding-progress-bar">
            <div className="onboarding-progress-fill" style={{ width: `${progressPercent}%` }} />
          </div>
          <span>{stepNumber}/{totalSteps}</span>
        </div>

        <h3 className="onboarding-title">{step.icon} {step.title}</h3>
        <p className="onboarding-text">{step.description}</p>
        {step.focus && <p className="onboarding-focus">{step.focus}</p>}

        {Array.isArray(step.walkthrough) && step.walkthrough.length > 0 && (
          <div className="onboarding-section">
            <h4>Step by step</h4>
            <ol className="onboarding-list">
              {step.walkthrough.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ol>
          </div>
        )}

        {Array.isArray(step.functions) && step.functions.length > 0 && (
          <div className="onboarding-section">
            <h4>Main functions</h4>
            <div className="onboarding-function-list">
              {step.functions.map((item) => (
                <div className="onboarding-function" key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <p className="onboarding-tip">Tip: {step.tip}</p>
        <p className="onboarding-replay-tip">You can replay this tutorial anytime from Settings.</p>

        <div className="onboarding-actions">
          <button
            className="onboarding-btn secondary"
            onClick={onBack}
            disabled={isFirstStep}
          >
            Back
          </button>
          <button className="onboarding-btn primary" onClick={onNext}>
            {isLastStep ? "Finish" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingTour;
